import Newsletter from './newsletter';

export const newsletterService = Newsletter;
